import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-btn_jinyong",
  "use": "icon-btn_jinyong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-btn_jinyong\"><path d=\"M512 96a416 416 0 1 0 0 832 416 416 0 0 0 0-832zM286.72 241.472a352 352 0 0 1 495.744 495.744L286.72 241.536z m-45.248 45.248l495.808 495.808A352 352 0 0 1 241.536 286.72z\" p-id=\"2925\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol